// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timer-box {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 2em;\n}\n[dir] .timer-box {\r\n  margin-bottom: 20px;\n}\n[dir] .time-unit {\r\n  background-color: #161d31;\r\n  padding: 4px 12px;\r\n  margin: 0 5px;\r\n  border-radius: 5px;\r\n  text-align: center;\n}\n[dir] .colon {\r\n  padding: 0 5px;\n}\r\n", ""]);
// Exports
module.exports = exports;
